/**
 * Home page carousels: arrows, progress bar and shelf tabs for the blocks in sections/plum-home.liquid.
 * Plain scroll-snap rows, so they also work by swiping; this script only adds the buttons, the bar and the tabs.
 */

function visibleTrack(shelf) {
  const tracks = [...shelf.querySelectorAll('[data-track]')];
  return tracks.find((track) => track.offsetParent !== null) ?? tracks[0] ?? null;
}

/** @param {HTMLElement} shelf */
function update(shelf) {
  const track = visibleTrack(shelf);
  if (!track) return;

  const max = track.scrollWidth - track.clientWidth;
  const ratio = max > 0 ? track.scrollLeft / max : 0;
  const bar = shelf.querySelector('[data-progress]');
  if (bar instanceof HTMLElement) {
    const share = max > 0 ? Math.max(0.15, track.clientWidth / track.scrollWidth) : 1;
    bar.style.width = `${share * 100}%`;
    bar.style.transform = `translateX(${ratio * (1 / share - 1) * 100}%)`;
  }

  shelf.querySelectorAll('[data-prev]').forEach((prev) => {
    if (prev instanceof HTMLButtonElement) prev.disabled = track.scrollLeft <= 2;
  });
  shelf.querySelectorAll('[data-next]').forEach((next) => {
    if (next instanceof HTMLButtonElement) next.disabled = track.scrollLeft >= max - 2;
  });
}

/** @param {HTMLElement} shelf @param {number} direction */
function move(shelf, direction) {
  const track = visibleTrack(shelf);
  if (!track) return;
  const card = track.firstElementChild;
  const step = card instanceof HTMLElement ? card.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
  track.scrollBy({ left: direction * step * 2, behavior: 'smooth' });
}

function setup(shelf) {
  if (!(shelf instanceof HTMLElement) || shelf.dataset.ready === 'true') return;
  shelf.dataset.ready = 'true';

  shelf.querySelectorAll('[data-track]').forEach((track) => track.addEventListener('scroll', () => update(shelf), { passive: true }));
  shelf.querySelectorAll('[data-prev]').forEach((button) => button.addEventListener('click', () => move(shelf, -1)));
  shelf.querySelectorAll('[data-next]').forEach((button) => button.addEventListener('click', () => move(shelf, 1)));

  shelf.querySelectorAll('.ph-tab').forEach((tab) => {
    tab.addEventListener('click', () => {
      shelf.querySelectorAll('.ph-tab').forEach((other) => other.setAttribute('aria-selected', String(other === tab)));
      shelf.querySelectorAll('.ph-panel').forEach((panel) => {
        panel.hidden = !(panel instanceof HTMLElement && panel.dataset.panel === tab.getAttribute('data-tab'));
      });
      update(shelf);
    });
  });

  update(shelf);
}

function init() {
  document.querySelectorAll('.ph [data-shelf]').forEach(setup);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();

window.addEventListener('resize', () => document.querySelectorAll('.ph [data-shelf]').forEach(update));
document.addEventListener('shopify:section:load', init);
